/**
 * Created by WebStorm.
 * User: nirongxu
 * Date: 2018/12/8
 * Description: 文件描述
 */
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
const cn = {
    routeName: {
        home: '主页',
        applicationList: '应用列表',
        user: '用户管理',
        publishArticle: '页面一',
        permissions: '权限管理',
        pageControl: '页面权限',
        PersonalCenter: '个人中心',
        personalCenter: '个人中心',
        parkingManagement: '停车场管理',
        parkingSetup: '停车场设置',
        parking: '车辆进出记录',
        visitorManagement: '访客机管理',
        visitorSetup: '访客机设置',
        visitorRegisterRecord: '访客登记记录',
        visitorAccessRecord: '访客通行记录',
        accessManagement: '门禁管理',
        access: '门禁记录',
        accessSetup: '门禁设置',
        faceManagement: '人脸管理',
        face: '人脸抓拍记录',
        faceSetup: '人脸机设置',
        // 门禁系统
        personnelManagement: '人员管理',
        personnelList: '人员名单',
        department: '部门管理',
        equipmentManagement: '设备管理',
        faceDevice: '人脸设备',
        statisticalReports: '统计报表',
        accessRecords: '通行记录',
        //人车布控
        controlCenter: '人车布控',
        controlTpye: '布控类型',
        controlVehicle: '车辆布控',
        vehicleWarning: '车辆预警记录',
        vehicleAcceptance: '车辆预警接收人',
        controlPersonnel: '人员布控',
        PersonnelWarning: '人员预警记录',
        PersonnelAcceptance: '人员预警接收人',
        FaceWarning: '人脸预警记录',
        FaceAcceptance: '人脸预警接收人',
        intelligenceWarning: '智能预警记录',
        intelligenceAcceptance: '智能预警接收人',
        /*安保制度*/
        securitymanagement: '安保制度管理',
        security: '安保制度',
        /*信息登记管理*/
        information: '信息登记管理',
        informationregistration: '信息登记',
        //微信设置
        wechat: '微信管理',
        wechatManagement: '微信人员管理',
        wechatMessage: "微信消息记录",
        //内保管理
        fileManagement: '内保通告管理',
        fileMessage: '内保通告',
        //排班管理
        schedulingManagement: "排班管理",
        schedulingPersonnelManagement: "排班人员管理",
        schedulingSettings: "排班设置",

        /*权限设置*/
        setting: "权限设置",
        permissionsetting: "权限管理",
        unitsetting: "单位管理",
        usersetting: "用户管理",
        print: "打印管理",

        /*基础设置*/
        ticketSetting: "基础设置",
        tickesSpot: "景区管理",
        ticketScenicname: "景点管理",
        ticketChecking: "验票站点",
        ticketGate: "设备管理",
        ticketEquipment: "状态监控",


        /*业务管理*/
        ticketManagement: "业务管理",
        ticketMaking: "票类管理",
        ticketCard: "会员卡管理",
        ticketStorage: "储值卡管理",
        ticketAuthentication: "人证核验",
        ticketMerchandise: "商品目录管理",
        ticketMerchandisekind: "商品类别管理",
        ticketPreferential: "票类优惠管理",
        ticketMatchingRules: "票种匹配规则",
        ticketCompensationPrice: "差价规则管理",
        ticketBilling: "计费管理",
        ticketVenue: "场馆设置",
        ticketVenuesetup: "场馆管理",
        ticketVenueplan: "场次计划",
        ticketTime: "通行日程管理",
        ticketGroup: "通行设备管理",
        ticketCalendar: "节假日管理",
        ticketControl: "区域管控",
        ticketTimeSharing: "分时管理",

        /*商品管理 */
        goods: "商品管理",
        shops: "商铺管理",
        commodity: "商品明细",
        gatalogue: "商品目录",
        goodsloading: "商品录入",
        Inventory: "商品库存明细",
        Commoditysales: "商品订单明细",
        Salesdetails: "商品销售明细",

        /*库存设置 */
        Warehouse: "库存设置",
        Entry: "门票录入",
        Ticket_Inventory: "门票库存",

        /*领票管理 */
        ticketCollection: "领票管理",
        ticketWarehouseManagement: "票库管理",
        ticketCollectionManagement: "领票管理",
        returnManagement: "退库管理",
        dataStatistics: "数据统计",

        /*查询报表*/
        ticketReport: "查询报表",
        ticketrOrder: "订单明细",
        ticketTicket: "票明细",
        ticketCode: "验证明细",
        ticketImport: "进出明细",
        ticketConsume: "会员刷卡明细",
        ticketActivate:"会员激活明细",
        ticketConsumestate: "未使用明细",
        ticketRefund: "退票明细",
        ticketInventory: "门票库存明细",
        ticketMerchandiseReport: "商品库车明细",
        ticketMerchandiseSale: "商品销售明细",
        ticketFlow: "来源明细",
        ticketStorageReport: "储值卡消费明细",
        Supplementary: "补取明细",
        statisticAnalysis: "统计分析",

        ticketInput: "库存管理",
        ticketType: "录入票类",
        ticketCommodity: "录入商品",

        /*股东设置*/
        Stockholder: "股东设置",
        Shareholder: "股东管理",
        Share: "股东权益",
        Statement: "收益明细",

        /*系统管理*/
        ticketsystem: "系统管理",
        ticketWechat: "微信设置",
        ticketAlipay: "支付宝设置",
        ticketDatabase: "数据库管理",
        ticketInformation: "系统信息",
        EquipmentUpgrade: "设备升级",
        ticketLog: "日志管理",

        /*信息发布管理*/
        release: "信息发布管理",
        programRelease: "节目设置",
        graphicRelease: "视频图文设置",
        contentRelease: "信息发布设置",
        dataRelease: "数据看板展示",
        ticketStatements: '财务报表',
        datalist: '数据中心',

        /*旅行社管理*/
        travelAgencyManagement: '旅行社管理',
        ticketTypeManagement: '票类管理',
        orderManagement: '订单管理',
        rechargeManagement: '充值管理',
        userManagement: '用户管理',
        financialStatements:'财务报表',
        test:'测试',

        /*旅行社菜单*/
        importOrder: '导入下单',
        travelAgencyOrderManagement_travelAgency: '订单管理',
        travelAgencyRechargeManagement: '充值管理',


        /*AI客流管理*/
        passenger: 'AI客流管理',
        camera: 'NVR设置',
        statistics: '客流分析',


        /*售票*/
        PrintTickets: "打印售票",
        ScanningTicketing: "扫描售票",
        MembershipCard: "会员卡",
        StoredCard: "储值卡",
        Refund: "退票退款",
        Collection: "门票处理",
        travelAgencyOrderManagement: "旅行社订单管理",
        Record: "当班记录",
        Query: "门票查询",
        Memberrenewal: "会员续费",
        sellPrintTickets: "打印售票",
        sellPrintTicketsgoods: "打印售票",
        sellScanningTicketing: "扫描售票",
        sellMembershipCard: "会员卡",
        sellStoredCard: "储值卡",
        sellgoods: "销售商品",
        scan: "扫描售票",
        sellRefund: "退票退款",
        sellCollection: "门票处理",
        sellRecord: "当班记录",
        ticketDetailsRecord: "门票详情记录",
        sellQuery: "门票查询",
        sellMemberrenewal: "会员续费",
        sellDifference: "票补差价",
        annualCardActivation: "年卡激活",

        /*旅行社权限*/
        importOrderPlacement: "导入下单",
    },
    home: {
        text1: "请输入登录账号",
        text2: "请输入登录密码",
        text3: "登录",
        /* 	text_:'欢迎使用中超大金古城票务系统',
                text:'中超大金古城票务系统', */
        text_: '欢迎使用智慧票务系统',
        text: '智慧票务系统',
        Refund: "退款总额",
        Cashrefunded: "退现金",
        Alipayback: "退支付宝",
        RefundWechat: "退微信",
        RefundUnionPay: "退银联",
        todayEnterCount: "当日入园",
        todayOfflineTicketCount: "当天线下购票数",
        todayOnlineTicketCount: "当天线上购票数",
        todayWeChatTicketCount: "当天微信购票数",

        entercount: "总入园人数",
        groupTicketCount: "总团体票数",

        cardTicketCount: "总会员卡数",
        ordinaryTicketCount: "总普通票数",
        enterCount: "总使用票数",
        onlineTicketCount: "线上购票总张数",
        offlineTicketCount: "线下购票总张数",

        weChatTicketCount: "微信购票张数",
        zdj: "终端机购票张数",
        dsf: "第三方购票张数",
        type: '类型分析',
        Ordinarycard: "普通卡",
        Membershipcard: "会员卡",
        Storedcard: "储值卡",
        VIP: '贵宾',
        family: "家庭",
        Ticketstatistics: "票类统计",
        Volume: "销量",
        Groupcard: "团体卡",
        Transactionanalysis: "交易分析",
        Cash: "现金",
        WeChat: "微信",
        Alipay: "支付宝",
        UnionPay: "银联",
        Bought: "挂账",
        Amount: "收银总额",
        Monday: "周一",
        Tuesday: "周二",
        Wednesday: "周三",
        Thursday: "周四",
        Friday: "周五",
        Saturday: "周六",
        Sunday: "周日",
        Total: "总量",
        Sourceanalysis: "来源分析",
        OTA: "OTA",
        OfflineWindow: "线下窗口",
        account: "公众号",
        Terminal: "终端机",
        visitorsflowrate: "客流分析",
        Touristtype: "来源地分析"

    },

    ticketspot: {
        id: "景区序号",
        name: "景区名称",
        add: "新增景区",
        placeholdername: "请输入景区名称",
        placeholderremark: "请输入景区备注",
        editspot: "编辑景区",
        errorspot: "景区名称长度不能大于16个字符",
        errorremark: "备注长度不能大于16个字符",


    },
    ticketScenic: {
        ScenicArea_: "请选择景区",
        Scenicname_: "请选择景点",
        id: "景点序号",
        name: "景点名称",
        ScenicArea: '所属景区',
        LimitEnable: "是否限制人数",
        LimitCount: "请输入限制人数",
        LimitCount_: "限制人数不能大于5个字符",
        add: "新增景点",
        placeholdername: "请输入景点名称",
        placeholderremark: "请输入景点备注",
        editspot: "编辑景点",
        errorspot: "景点名称长度不能大于16个字符",
        errorremark: "备注长度不能大于16个字符",

    },
    ticketgate: {
        constStatus: "开门模式",
        ck: "常开模式",
        cb: "常闭模式",
        pt: "普通模式",
        qx: "下发权限",
        id: "设备序号",
        name: "设备名称",
        ScenicArea: '所属景区',
        zone: "所属景点",
        deviceNo: "设备编码",
        moduleType: "设备类型",
        deviceIP: "设备IP",
        online: "设备状态",
        webPort: "设备端口号",
        createTime: "添加日期",

        zx: "在线",
        lx: "离线",
        kz: "远程开闸",
        qc: "清除数据",
        addgate: "新增设备",
        deviceNo_: "请输入设备编码",
        name_: "请输入设备名称",
        print: "打印模板",
        numberzs: "售票机纸张数",
        numberzs_: "请输入售票机打印纸张数",
        ucOpenDoorType: "开门类型",
        ucCommuTyp: "485通讯方式",

        uc485Id: "485通讯ID",
        deviceIP_: "请输入设备IP",
        webPort_: "请输入设备端口号",
        editgate: "编辑设备",
        deviceNo_a: "设备编码不能为空",
        name_a: "设备名称不能为空",
        device_a: "请选择设备类型",
        ScenicArea_: "请选择景区",
        zone_: "请选择景点",
        moduleType_: " 请选择设备类型",
        Ip: " 设备IP不能为空",
        Ip_: " 设备IP格式不正确",
        Enter: "进",
        Out: "出",
        door_: "智能通道闸",
        Gate: "智能通道闸",
        Terminal: "自助售取票终端",
        Handheld: "手持售取票终端",
        relay: "继电器开门",
        gateplate: "闸机板开门",
        control: "门禁",
        Enable: "启用",
        Disable: "禁用",
        Import: "进口",
        Export: "出口",
        scope: "此操作将控制设备开一次门, 是否继续?",
        qxscope: "此操作会将票类型参数，门票数据，门票对应权限，等参数下发至设备, 是否继续?",
        qxscope_: "下发成功",
        qxscope_a: "下发失败",
        door: "开门成功",
        failure: "开门失败",
        Cancel: "取消操作",
        scope_: "此操作将使票务控制器内的数据库清空,清除完成后您需要将该设备跟票类管理内的票种权限重新编辑, 是否继续?",
        Cleared: "清除成功",
        Cleared_: "清除失败",
        IDuc485Id_: " 大小不能大于255",
        deviceNo_: " 设备名称长度不能大于16个字符",
        ucOpenDoorType_: "请选择开门类型",
        IDuc485Id_a: "485通讯方式不能为空",
        IDuc485Id_b: "485ID不能为空",
        print_: "请选择打印模板",
        printTicketCount: "打印张数不能为空",
        deviceIPlength: "IP长度不能大于15个字符",
        namelength: "设备名称长度不能大于16个字符",
    },

    ticketmaking: {
        id: "票类ID",
        name: "票类名称",
        ticketPrice: "票价格",
        // ticketMedium:"票介质",
        ticketCate: "票类别",
        ticketFeeMethod: "计费方式",
        scenicAreaID: "所属景区",
        scenicAreaID_: "景区ID",
        ticketZone_query: "票权限设置",

        add: "新增票类型",
        ticketTypeName: "票名称",
        ticketTypeName_: "请输入票名称",
        ticketDisplayPrice: "对外销售价格",
        ticketDisplayPrice_: "请输入对外销售票价",
        ticketPrice: "票价格",
        ticketPrice_: "请输入票价格",
        ticketMedium: "门票介质",
        ticketFeeMethod: "计费方式",
        ticketCate: "门票类别",
        ticketTypeStartingType: "起算方式",
        ticketTypeStartingDate: "起算日期",
        date: "选择日期",
        ticketUseDays: "有效期(天)",
        refundRuleID: "退票规则",
        limitCount: "微信限制购票张数",
        limitCount_: "为0时默认不限制",
        patchCard: "补卡手续费",
        checkVal: "载入平台",
        checkbox1: "公众号",
        checkbox2: "终端机",
        checkbox3: "第三方",
        checkbox5: "手持机",
        checkbox4: "小程序",
        headPhoto: "票类照片",
        headPhoto1: "上传图片",
        headPhoto2: "只能上传jpg/png文件,且不超过1MB (限制只能上传一张图片)",
        edit: "编辑票类型",
        makForm: "票权限参数列表",
        addmakForm: "添加票权限参数",

        FeeMethod: "通行方式",
        id_: "序列ID",
        scenicAreaID_: "绑定景点",
        passDeviceList: "绑定设备",
        useTimesByDay: "有效次数",
        useTimes: "总次数",
        ticketValidDays: "有效天数",
        ticketValidTime: "有效时间",
        addsetForm: "添加票权限参数",
        zone: "所属景点",
        second: "日次数",
        second_: "请输入日次数",
        totalSecond: "请输入总次数",
        throughGroupID_: "绑定通行权限日程",
        Billing: "绑定计费规则",
        isloadedTicket: "是否载入售票端",
        totalTime: "总时间(分钟)",
        totalTime_: "请输入总时间",
        totalday: "总天数",
        totalday_: "请输入总天数",
        pair: "是否进出配对",
        name_: "设备名称",
        direction: "进出方向",
        editsetForm: "编辑票权限参数",
        Medium: "请选择介质",
        Billing: "请选择计费方式",
        Category: "请选择类别",
        Effective: "请输入有效期",
        Company: "请选择景区",
        TicketTypeStartingType: "请选择起算类型",
        TicketDisplayPrice: "请输入对外销售价格",
        jt: "今天",
        zt: "昨天",
        yz: "一周前",
        qr: "二维码卡",
        ic: "IC卡",
        sfz: "身份证",
        rl: "人脸",

        jc: "计次",
        js: "计时",

        sfzyhk: "身份证免费卡",
        areaName: "免费地区关键字,多个地区用符合,逗号隔开",
        areaName_: "输入地区关键字,多个地区用符合,逗号隔开例如北京,深圳",
        minAge: "免费限制年龄",
        passMode: "免费规则",
        passMode1: "按年龄",
        passMode2: "按地域",
        passMode3: "年龄或地域",
        passMode4: "年龄与地域",

        ticketAudioEnable: "是否开启语音",
        ticketAudioEnable0: "不开启",
        ticketAudioEnable1: "开启",

        Type1: "按办卡日期",
        Type2: "按自然月(下月一号)",
        Type3: "自定义",
        Type4: "按截止日",
        loaded: "载入",
        loaded_: "不载入",
        throughGroupID: "不选择",
        ptk: "普通卡",
        ttk: "团体卡",
        fkm: "付款码",
        tqk: "特权卡",
        nk: "会员年卡",
        bnk: "会员半年卡",
        jdk: "会员季度卡",
        yk: "会员月卡",
        zdrk: "自定义日卡",
        zdyk: "自定义月卡",
        zdnk: "自定义年卡",
        zzk: "储值卡",
        rc: "不绑定日程",
        namelength: "票名称长度不能大于16个字符",
        ticketUseDayslength: "有效长度不能大于5个字符",
        limitCountlength: "微信限制长度不能大于5个字符",
        patchCardlength: "补卡长度不能大于5个字符",
        ticketPricelength: "票价格长度不能大于5个字符",
        useTimeslength: "总次数不能大于6个字符长度",
        useTimesByDaylength: "日次数不能大于6个字符长度",
        useTimesByDay_: "日次数不能大于总次数",
        ticketTime: "请输入时间",
        ticketValidTime_: "时间不能大于4个字符长度",
        arrList: "请选择对应的设备",
        ticketValidDays_: "天数不能大于4个字符长度",
        calcRuleName: "不绑定规则",
        rca: "进",
        cca: "出",
    },

    ticketstorage: {
        card: "票号/卡号",
        card_: "输入票号/卡号",
        name: "姓名",
        name_: "输入姓名",
        Mobile: "手机号",
        Mobile_: "输入手机号",
        type: "票类型",
        query: "查询信息",
        ticketID: "票号",
        ticketPrice: "单价",
        ticketTypeName: "票类名称",
        ticketBalance: "余额",
        ticketCate: "票类别",
        ticketFeeMethod: "票介质",
        ticketStatus: "票状态",
        ticketUserName: "姓名",
        ticketUserMobile: "电话",
        ticketStart: "游玩日期",
        subTicketID: "子票号",
        ticketEnd: "结束时间",
        account: "售票员",
        scope: "操作",
        cardmodal: "编辑会员个人信息",
        ticketTypeName_name: "持卡人姓名",
        ticketUserIDNum: "身份证号",
        ticketTypeName_card: "持卡人卡号",
        ticketUserMobile: "持卡人电话",
        ticketStart: "有效期开始",
        ticketEnd: "有效期结束",
        headPhoto: "照片",
        headPhoto_: "上传图片",
        qbzt: "全部状态",
        wyp: "未验票",
        yyp: "已验票",
        ytp: "已退票",
        yzf: "已作废",
        yjy: "已禁用",
        ygs: "已挂失",
        ygq: "已过期",
        ticketTypeName_qb: "全部票类",
        mzzd: "名称长度不能大于12个字符",
        sfzzd: "身份证名称长度不能大于18个字符",
        sjzzd: "手机号名称长度不能大于11个字符",
        sjzzd: "卡长度不能大于24个字符",
        mzzd_: "姓名长度不能大于10个字符",
    },


    ticketcard: {
        card: "票号/卡号",
        card_: "输入票号/卡号",
        name: "姓名",
        name_: "输入姓名",
        Mobile: "手机号",
        Mobile_: "输入手机号",
        type: "票类型",
        query: "查询信息",
        ticketID: "卡号",
        ticketPrice: "单价",
        ticketTypeName: "卡类名称",
        ticketCate: "票类别",
        ticketBalance: "余额",
        ticketTypeName_: "票名称",
        ticketFeeMethod: "票介质",
        ticketStatus: "票状态",
        ticketUserName: "姓名",
        ticketUserMobile: "电话",
        validityConfig: "有效期配置",
        ticketStart: "开始日期",
        ticketEnd: "结束时间",
        account: "售票员",
        subTicketID: "卡参数",
        updataForm: "编辑会员个人信息",

        ticketUserIDNum: "身份证号",
        headPhoto_: "照片",
        primary: "操作",
        headPhoto_primary: "上传图片",
        headPhoto: "只能上传jpg/png文件,且不超过1MB (限制只能上传一张图片)",

        updata: "确 定",
        closeForm: "取 消",
        qbzt: "全部状态",
        wyp: "未验票",
        yyp: "已验票",
        ytp: "已退票",
        yzf: "已作废",
        yjy: "已禁用",
        ygs: "已挂失",
        ygq: "已过期",
        qb: "全部票类",
        error1: "名称长度不能大于12个字符",
        error2: "身份证名称长度不能大于18个字符",
        error3: "手机号名称长度不能大于11个字符",
        success: "编辑信息成功",
        error4: "编辑信息失败",

        error5: "卡长度不能大于24个字符",
        error6: "电话长度不能大于11个字符",
        error7: "姓名长度不能大于10个字符",

        ptk: "普通卡",
        zzk: "储值卡",
        ttk: "团体卡",
        nk: "会员年卡",
        bnk: "会员半年卡",
        jdk: "会员季度卡",
        yk: "会员月卡",

        fkm: "付款码",
        tqk: "特权卡",
        zdrk: "自定义日卡",
        zdyk: "自定义月卡",
        zdnk: "自定义年卡",
        rl: "人脸",
        jc: "计次",
        js: "计时",
        rk: "已入库",
        ck: "已出库",

        headPhoto1: "上传头像图片只能是 JPG 或者PNG 格式",

        headPhoto2: "上传头像图片大小不能超过 1MB",

    },
    ticketAuth: {
        id: "序号",
        scenicAreaID: "所属景区",
        isEnable: "是否启用",
        ticketTypeName: "绑定票类型",
        scope: "操作",
        company: "所属景区",
        addForm: "新增人证核验票类",
        ticket: "所属票类型",
        out: "是否启用",
        resetForm: "重 置",
        primary: "确 定",
        closeForm: "取 消",
        Error1: "请选择景区",
        Error2: "请选择票类型",
        yes: "是",
        no: "否",
        isEnable1: "禁用",
        isEnable2: "启用",
        success: "添加信息成功",
        error: "添加信息失败",
        success1: "编辑信息成功",
        error1: "编辑信息失败",
        delete: "此操作将永久删除该数据, 是否继续?",
        delete1: "删除信息成功",
        delete2: "删除信息失败",
    },
    ticketpre: {
        id: "优惠ID",
        discountName: "优惠名称",
        scenicAreaID: "所属景区",
        discountCategory: "优惠类别",
        discountType: "优惠类型",
        scope: "操作",
        addForm: "新增优惠规则",
        discountName: "优惠名称",
        discountName_: "请输入优惠名称",
        company: "所属景区",
        discountCategory: "选择优惠类别",
        radio0: "满金额优惠",
        M: "满",
        je: "减",
        y: "元",
        radio1: "满金额打折",
        da: "打",
        ze: "折",
        radio2: "满张数优惠",
        radio3: "满张数打折",
        text: "折扣输入说明例如打8.8折，必须输入88，不然无效，打9折。输入90即可。",
        radio4: "满充值金额",
        co: "充",
        so: "送",
        resetForm: "取 消",
        primary: "确 定",
        updataForm: "编辑优惠规则",
        Error1: "请选择景区",
        Error2: "请选择优惠类别",
        Error3: "请输入名称",
        label1: " 购票优惠",
        label2: " 充值优惠",
        error1: "名称长度不能大于24个字符",
        error2: "请选择优惠规则",
        error3: "规则里面的数据不能为空",
        success: "添加信息成功",
        error: "添加信息失败",
        success1: "编辑信息成功",
        delete: "此操作将永久删除该数据, 是否继续?",
        warning: "提示",
        delete1: "删除信息成功",
        delete2: "删除信息失败",
    },
    ticketMatchingRules: {
        discountName: "规则名称",
        scenicAreaID: "所属景区",
        ticketType: "绑定票种",
        remark: "备注",
        scope: "操作",
        addForm: "新增匹配规则",
        updataForm: "编辑匹配规则",
        discountName_: "请输入规则名称",
        province: "选择地域",
        province_: "请选择地域",
        sex: "选择性别",
        sex_: "请选择性别",
        timePeriodName: "时段名",
        timePeriodName_: "请输入时段名",
        resetForm: "取 消",
        primary: "确 定",

    },

    ticketprice: {
        id: "序号",
        scenicAreaID: "所属景区",
        name: "差价规则名称",
        ticketType: "绑定票类型",
        scope: "操作",
        addForm: "新增差价规则",
        company: "所属景区",
        type: "所属票类型",
        gracePeriod: "补完宽限时长",
        label1: "第一阶段",
        label2: "第二阶段",
        label3: "第三阶段",
        label4: "第四阶段",
        YItime: "超过时间(分)",
        YIprice: "需补金额(元)",
        reset: "重 置",
        primary: "确 定",
        close: "取 消",
        updataForm: "编辑名称",
        Error1: "请输入名称",
        Error2: "请选择景区",
        Error3: "请选择票类型",
        error1: "名称长度不能大于12个字符",
        error2: "第一阶段超时时间，需补金额不能为空",
        error3: "第一阶段超时时间，需补金额输入不正确不能小于0",
        error4: "超时时间，需补金额输入不正确不能小于0",
        error5: "第二阶段需补金额输入不能为空",
        error6: "第二阶超时时间输入不能为空",
        error7: "第三阶段需补金额输入不能为空",
        error8: "第三阶超时时间输入不能为空",
        error9: "第四阶段需补金额输入不能为空",
        error10: "第四阶超时时间输入不能为空",
        error11: "超时的时间不能大于5个字符",
        error12: "需补金额不能大于8个字符",
        successadd: "添加信息成功",
        erroradd: "添加信息失败",
        successedit: "编辑信息成功",
        erroredit: "编辑信息失败",
        delete: "此操作将永久删除该数据, 是否继续?",
        warning: "提示",
        deletesuccess: "删除信息成功",
        deleteerror: "删除信息失败",
    },
    ticketBilling: {

        id: "序号",
        calcRuleName: "计费名称",
        scenicArea: "所属景区",
        calcRuleType: "计费类型",
        remark: "计费说明",
        scope: "操作",
        addForm: "新增计费规则设置",
        calcRuleName: "计费规则名称",

        billingtype: "计费类型",
        company: "所属景区",
        out: "是否允许外出",
        allowOutTimeSpan: "允许外出时间(分钟)",
        isAllowUnitSpanDeduction: "是否整扣",
        deductionUnitSpan: "允许整扣时长(分钟)",
        startPrice: "起步价(元)",

        maxDayAmount: "日封顶金额(元)",

        maxTotalAmount: "总封顶金额(元)",
        startFreeTime: "免费时长(分钟)",
        graceSpan: "宽限时长(分钟)",
        deductionGranularity: "扣费粒度(元)",
        dayType: "每日截止类型",

        label1: "时间段一",
        start: "起始",
        end: "结束",
        YItime: "按每几分钟开始扣费",
        YItime_: "请输入分钟数",
        YIprice: "扣费金额(元)",
        YIprice_: "请输入扣费金额",
        label2: "时间段二",
        label3: "时间段三",
        label4: "时间段四",
        label5: "时间段五",
        label6: "周末 (周六，周天)",
        label7: "节假日",

        time1: "节假日起始日期",
        time2: "选择日期",
        time3: "节假日结束日期",
        time4: "节假日时间段",
        reset: "重 置",
        primary: "确 定",
        updataForm: "编辑规则",

        Error1: "请输入规则名称",
        Error2: "请选择景区",
        Error3: "请选择计费方式",
        text1: "今天",
        text2: "昨天",
        text3: "一周前",
        jc: "计次",
        js: "计时",
        yes: "是",
        no: "否",
        value1: "不允许",
        value2: "允许",
        value3: "自然日",
        value4: "24小时计算",

        error: "起始时间段不能为空",
        error1: "第一时段填写不正确",
        error2: "第二时段填写不正确",
        error3: "第三时段填写不正确",
        error4: "第四时段填写不正确",
        error5: "第五时段填写不正确",

        error6: "第一时段的结束时间不能小于开始时间",
        error7: "第二时段的结束时间不能小于开始时间",
        error8: "第三时段的结束时间不能小于开始时间",
        error9: "第四时段的结束时间不能小于开始时间",
        error10: "第五时段的结束时间不能小于开始时间",

        error11: "填写不正确，第一时段结束大于第二时间段开始",
        error12: "填写不正确，第二时段结束大于第三时间段开始",
        error13: "填写不正确，第三时段结束大于第四时间段开始",
        error14: "填写不正确，第四时段结束大于第五时间段开始",
        error15: "节假日结束时间不能大于开始时间",

        zmerror: "周末起始时间段不能为空",
        zmerror1: "周末第一时段填写不正确",
        zmerror2: "周末第二时段填写不正确",
        zmerror3: "周末第三时段填写不正确",
        zmerror4: "周末第四时段填写不正确",
        zmerror5: "周末第五时段填写不正确",
        zmerror6: "周末第一时段的结束时间不能小于开始时间",
        zmerror7: "周末第二时段的结束时间不能小于开始时间",
        zmerror8: "周末第三时段的结束时间不能小于开始时间",
        zmerror9: "周末第四时段的结束时间不能小于开始时间",
        zmerror10: "周末第五时段的结束时间不能小于开始时间",

        Terror1: "填写不正确，第一时段结束大于第二时间段开始",
        Terror2: "填写不正确，第二时段结束大于第三时间段开始",
        Terror3: "填写不正确，第三时段结束大于第四时间段开始",
        Terror4: "填写不正确，第四时段结束大于第五时间段开始",
        Terror5: "填写不正确，周末第一时段结束大于第二时间段开始",
        Terror6: "填写不正确，周末第二时段结束大于第三时间段开始",
        Terror7: "填写不正确，周末第三时段结束大于第四时间段开始",
        Terror8: "填写不正确，周末第四时段结束大于第五时间段开始",

        Terror9: "节假日的选择开始日期不能为空",
        Terror10: "节假日的选择结束日期不能为空",
        Terror11: "节假日的开始时间不能为空",
        Terror12: "节假日的结束时间不能小于开始时间",
        Terror13: "节假日的时间段填写不对",
        close: "取 消",
        successadd: "添加信息成功",
        erroradd: "添加信息失败",
        successedit: "编辑信息成功",
        erroredit: "编辑信息失败",
        delete: "此操作将永久删除该数据, 是否继续?",
        warning: "提示",
        deletesuccess: "删除信息成功",
        deleteerror: "删除信息失败",

    },

    tickeTime: {
        id: "景区序号",
        scenicAreaID: "所属景区",
        name: "通行权限名称",
        scope: "操作",
        addForm: "新增时间段",

        company: "所属景区",
        YItime1: "星期一",
        YItime2: "星期二",
        YItime3: "星期三",
        YItime4: "星期四",
        YItime5: "星期五",
        YItime6: "星期六",
        YItime7: "星期天",
        YItime8: "节假日",
        start: "起始",
        end: "结束",
        reset: "重 置",
        primary: "确 定",
        updataForm: "编辑名称",
        error1: "请输入日程名称",
        error2: "请选择景区",
        error3: "名称长度不能大于12个字符",
        errorx1: "第一段的开始时间不能为空",
        errorx2: "星期一的结束时间不能小于开始时间",
        errorx3: "星期二的结束时间不能小于开始时间",
        errorx4: "星期三的结束时间不能小于开始时间",
        errorx5: "星期四的结束时间不能小于开始时间",
        errorx6: "星期五的结束时间不能小于开始时间",
        errorx7: "星期六的结束时间不能小于开始时间",
        errorx8: "星期天的结束时间不能小于开始时间",
        errorx9: "节假日的结束时间不能小于开始时间",
        errorxx1: "填写错误，第一时间段不能为了空，才可填写第二时间段",
        errorxx2: "填写错误，第二时间段不能为了空，才可填写第三时间段",
        reset: "重 置",
        primary: "确 定",
        close: "取 消",
        successadd: "添加信息成功",
        erroradd: "添加信息失败",
        successedit: "编辑信息成功",
        erroredit: "编辑信息失败",
        delete: "此操作将永久删除该数据, 是否继续?",
        warning: "提示",
        deletesuccess: "删除信息成功",
        deleteerror: "删除信息失败",
    },

    ticketprint: {
        id: "序号",
        namedata: "所属景区",
        templateName: "打印模板名称",
        templatePath: "打印路径",
        useSourceType: "应用场景",
        isEnablePrint: "是否启用",
        scope: "操作",

        addForm: "新增打印模板",
        printType: "打印机型号",
        company: "所属景区",
        prop: "打印模板",
        propsm: "打印模板说明",
        text: "设置的打印模块字段，必须跟选择勾选的打印内容必须一一对应",
        seqID: "序号",
        QR: "二维码",
        ticketID: "票号信息",
        ticketTypeName: " 票类型",
        ticketStartTime: "有效开始时间",
        ticketEndTime: "有效结束时间",
        ticketDisplayPrice: " 票价",
        touristName: " 持卡人姓名",
        touristMobile: "持卡人手机号",
        touristIDCardNum: "持卡人身份证号码",
        sellName: "售票员名称",
        byTicketTime: "购票时间",
        name: "游客姓名",
        reset: "重 置",
        primary: "确 定",
        close: "取 消",


        error1: "请输入模板名称",
        error2: "请输入路径",
        error3: "请选择景区",
        yes: "是",
        no: "否",
        print1: "得实",
        print2: "得实小票80",
        print3: "美松80",
        print4: "驱动打印",
        value1: "窗口售票",
        value2: "自助售取票机",

        error: "名称长度不能大于12个字符",
        successadd: "添加信息成功",
        erroradd: "添加信息失败",
        successedit: "编辑信息成功",
        erroredit: "编辑信息失败",
        delete: "此操作将永久删除该数据, 是否继续?",
        warning: "提示",
        deletesuccess: "删除信息成功",
        deleteerror: "删除信息失败",

        qy: "查找管控区域",
        add: "添加待授权区域",
        regionName: "所属区域",
        add: "添加待授权区域",
        regionCode: "所属编码",
        scope: "操作",
        updata: "授权管控",
        updatatext: "(当区域一个都不选择的时候在授权,系统默认取消管控授权)",
        updata: "授权管控",
        error4: "请选择票类型",
        error5: "添加失败,请先选择区域",
        error6: "添加失败,不能添加重复的区域",
        error7: "授权区域成功",
        error8: "授权区域失败",
        error9: "该区域已经授权无法删除,取消勾选授权后在操作",

    },
    ticketsharing: {
        id: "景区序号",
        name: "名称",
        startPeriod: "开始时间段",
        endPeriod: "结束时间段",
        limitCount: "可预约人数",

        scenicAreaID: "所属景区",
        scope: "操作",
        addForm: "新增预约时间段",
        appointmentConfigName: "预约时段名称",
        company: "所属景区",
        prop: "时间段",
        start: "起始",
        end: "结束",
        reset: "重 置",
        primary: "确 定",
        close: "取 消",
        updataForm: "编辑名称",
        text: "输入可预约数为0时不限制",

        Error1: "请输入日程名称",
        Error2: "请选择景区",
        Error3: "请输入预约人数",
        Error4: "名称长度不能大于12个字符",
        Error5: "输入人数不能小于0",
        Error6: "人数长度不能大于7个字符",
        Error7: "开始时间不能为空",
        Error8: "结束时间不能为空",
        Error9: "结束时间不能小于开始时间",

        successadd: "添加信息成功",
        erroradd: "添加信息失败",
        successedit: "编辑信息成功",
        erroredit: "编辑信息失败",
        deletesuccess: "删除信息成功",
        deleteerror: "删除信息失败",
        delete: "此操作将永久删除该数据, 是否继续?",
        warning: "提示",

    },
    ticketsetting: {
        id: "序号",
        name: "权限名称",
        namedata: "所属景区",
        isEnable: "是否启用",
        scope: "操作",
        addForm: "新增权限",
        label: "权限角色区分",
        radio_0: "管理员",
        radio_1: "售票员",

        setting: "权限设置",
        permissionsetting: "权限管理",
        unitsetting: "单位管理",
        usersetting: "用户管理",
        print: "打印管理",
        ticketSetting: "基础设置",
        tickesSpot: "景区管理",
        ticketScenicname: "景点管理",
        ticketChecking: "验票站点",
        ticketGate: "设备管理",
        ticketEquipment: "状态监控",
        /*票务业务管理*/

        ticketManagement: "业务管理",
        ticketMaking: "票类管理",
        ticketCard: "会员卡管理",
        ticketStorage: "储值卡管理",
        ticketAuthentication: "人证核验",

        ticketMerchandise: "商品目录管理",
        ticketMerchandisekind: "商品类别管理",
        ticketPreferential: "票类优惠管理",
        ticketMatchingRules: "票种匹配规则",
        ticketCompensationPrice: "差价规则管理",
        ticketBilling: "计费管理",

        ticketVenue: "场馆设置",
        ticketVenuesetup: "场馆管理",
        ticketVenueplan: "场次计划",
        ticketTime: "通行日程管理",
        ticketGroup: "通行设备管理",
        ticketCalendar: "节假日管理",
        ticketControl: "区域管控",
        ticketTimeSharing: "分时管理",
        /*查询报表*/

        ticketReport: "查询报表",
        ticketrOrder: "订单明细",
        ticketTicket: "票明细",
        ticketCode: "验证明细",
        ticketImport: "进出明细",
        ticketConsume: "会员刷卡明细",
        ticketActivate:"会员激活明细",
        ticketConsumestate: "未使用明细",

        ticketInventory: "门票库存明细",
        ticketMerchandiseReport: "商品库车明细",
        ticketMerchandiseSale: "商品销售明细",
        ticketFlow: "来源明细",
        ticketStorageReport: "储值卡消费明细",
        statisticAnalysis: "统计分析",

        ticketCollection: "领票管理",
        ticketWarehouseManagement: "票库管理",
        ticketCollectionManagement: "领票管理",
        returnManagement: "退库管理",
        dataStatistics: "数据统计",

        ticketInput: "库存管理",
        ticketType: "录入票类",
        ticketCommodity: "录入商品",

        ticketsystem: "系统管理",
        ticketWechat: "微信设置",
        ticketAlipay: "支付宝设置",
        ticketDatabase: "数据库管理",
        ticketInformation: "系统信息",
        EquipmentUpgrade: "设备升级",
        ticketLog: "日志管理",


        release: "信息发布管理",
        programRelease: "节目设置",
        graphicRelease: "视频图文设置",
        contentRelease: "信息发布设置",
        dataRelease: "数据看板展示",
        ticketStatements: "财务报表",

        /*旅行社管理*/
        travelAgencyManagement: '旅行社管理',
        ticketTypeManagement: '票类管理',
        orderManagement: '订单管理',
        rechargeManagement: '充值管理',
        userManagement: '用户管理',
        financialStatements: '财务报表',

        sell: "售票管理",
        /*售票*/
        PrintTickets: "打印售票",
        sellPrintTicketsgoods: "购物车模式",
        ScanningTicketing: "扫描售票",
        MembershipCard: "会员卡",
        StoredCard: "储值卡",
        Refund: "退票退款",
        Collection: "门票处理",
        travelAgencyOrderManagement: "旅行社订单管理",
        Record: "当班记录",
        Query: "门票查询",
        Memberrenewal: "会员续费",
        sellPrintTickets: "打印售票",
        sellScanningTicketing: "扫描售票",
        sellMembershipCard: "会员卡",
        sellStoredCard: "储值卡",
        sellRefund: "退票退款",
        sellCollection: "门票处理",
        sellRecord: "当班记录",
        sellQuery: "门票查询",
        sellMemberrenewal: "会员续费",
        sellDifference: "票补差价",

        updataForm: "编辑权限",
        Error1: "请输入权限名称",
        Error2: "请选择景区",
        label1: "启用",
        label2: "不启用",

        error1: "名称长度不能大于12个字符",
        error2: "请勾选需要开放的权限功能",

        successadd: "添加信息成功",
        erroradd: "添加信息失败",
        successedit: "编辑信息成功",
        erroredit: "编辑信息失败",
        delete: "此操作将永久删除该数据, 是否继续?",
        warning: "提示",
        deletesuccess: "删除信息成功",
        deleteerror: "删除信息失败",
        reset: "重 置",
        primary: "确 定",
        close: "取 消",
    },

    ticketuser: {
        id: "用户ID",
        account: "用户名称",
        name: "权限名称",
        namedata: "所属景区",
        namedataid: "所属景区ID",
        isEnable: "是否启用",
        scope: "操作",
        cz: "重置密码",
        addForm: "新增用户",
        name_: "用户名称",
        password: "账号密码",
        passworddata: "确认密码",
        passworddata: "确认密码",
        company: "所属景区",
        zone: "所属景点",
        user: "选择权限",
        updataForm: "编辑用户",
        password: "新密码",
        passworddata_: "确认新密码",
        Error1: "请输入名称",
        Error2: "请输入密码",
        Error3: "请确认密码",
        Error4: "请选择权限",
        Error5: "请选择景区",
        label1: "启用",
        label2: "不启用",
        error1: "名称长度不能大于12个字符",
        error2: "备注长度不能大于64个字符",
        error3: "密码长度不能大于16个字符",
        error4: "俩次输入的密码不一致",

        error5: "重置密码成功",
        error6: "重置密码失败",
        error7: "不能删除当期使用的账号",

        successadd: "添加信息成功",
        erroradd: "添加信息失败",
        successedit: "编辑信息成功",
        erroredit: "编辑信息失败",
        delete: "此操作将永久删除该数据, 是否继续?",
        warning: "提示",
        deletesuccess: "删除信息成功",
        deleteerror: "删除信息失败",
        remarks: "备注",
        reset: "重 置",
        primary: "确 定",
        close: "取 消",
    },
    ticketorder: {

        timeList: "下单日期",
        createTime: "创建时间",
        zhi: "至",
        start: "开始日期",
        end: "结束日期",
        start: "开始日期",
        scenicArea: "景区",
        zone: "景点",
        cardlist: "订单号",
        name: "姓名",
        fs: "支付方式",
        zt: "状态",
        qd: "渠道",
        yh: "用户",
        query: "查询信息",
        orderID: "订单号",
        excel: "导出报表",
        ticketNum: "张数",
        orderAmount: "订单金额",
        preferentialAmount: "优惠金额",
        orderTime: "下单时间",
        orderPayment: "支付方式",
        orderStatus: "状态",
        account: "售票员",
        scope: "操作",
        orderData: "查看订单详情",
        makForm: "门票详情",
        ticketID: "票号",
        ticketStatus: "票状态",
        ticketTypeName: "票名称",
        ticketPrice: "单价",
        ticketUserName: "姓名",
        ticketUserMobile: "电话号码",
        ticketUserIDNum: "身份证",
        ticketStart: "游玩时间",
        ticketEnd: "过期时间",
        value1: "全部",
        value2: "窗口售票",
        value3: "OTA第三方",
        value4: "公众号",
        value5: "终端机",
        value6: "手持机",

        label1: "全部",
        label2: "购票已付款",
        label3: "购票未付款",
        label4: "退票未退款",
        label5: "退票已退款",

        fs1: "全部",
        fs2: "现金",
        fs3: "微信付款码",
        fs4: "小程序付款",
        fs5: "公众号付款",
        fs6: "支付宝付款码",
        fs7: "银联卡",
        fs8: "线上支付",
        fs9: "羊城通",
        fs10: "微信扫一扫",
        fs11: "支付宝扫一扫",
        fs12: "挂账",

        text1: "最近一周",
        text2: "最近一个月",
        text3: "最近三个月",

        text: "订单明细",
        account_: "全部人员",

        error1: "卡长度不能大于24个字符",
        error2: "电话长度不能大于11个字符",
        error3: "姓名长度不能大于10个字符",

        zt0: "已入库",
        zt1: "已出库",

        zt2: "未验票",
        zt3: "已验票",
        zt4: "已退票",
        zt5: "已作废",
        zt6: "已禁用",
        zt7: "已挂失",
        zt8: "已过期",
        zt9: "已使用退票",
        zt10: "未激活",
        zt11: "部分使用",
        timeListx: "购票日期",
        card: "票号/卡号",

        Mobile: "手机号",
        type: "票类型",
        ticketCate: "票类别",
        ticketFeeMethod: "票介质",

        ticketUserResidence: "地址",
        ticketUserCompany: "单位",
        zoneData: "对应景点参数",
        makForm_: "门票景点参数详情",
        remainTimesByDay: "剩余总次数",
        remainTimes: "剩余日次数",
        remainValidTime: "剩余时间",

        ptk: "普通卡",
        ttk: "团体卡",
        fkm: "付款码",
        tqk: "特权卡",
        nk: "会员年卡",
        bnk: "会员半年卡",
        jdk: "会员季度卡",
        yk: "会员月卡",
        zdrk: "自定义日卡",
        zdyk: "自定义月卡",
        zdnk: "自定义年卡",
        zzk: "储值卡",
        sfz: "身份证免费卡",
        Error1: "请选择景区",
        Error2: "票明细",
        wu: "无",
        rl: "人脸",
        jc: "计次",
        js: "计时",
        textx: "验证详情及票参数",
        yztime: "验证时间",
        timelist_x: "出入日期",
        sb: "设备",
        fx: "方向",
        deviceName: "通行设备",
        zoneName: "景点",
        recordTime: "入园时间",
        direction: "进出方向",
        temperature: "温度值",
        openNumber: "开门次数",
        fx1: "全部",
        fx2: "进",
        fx3: "出",
        out: "进出明细",
        type_: "全部票类",
        sb_: "全部设备",
        timelist_c: "查询日期",
        time: "时间",
        orderCount: "订单数",
        amount: "订单金额",
        actualAmount: "实际金额",
        refundAmount: "退票金额",
        ticketCount: "票张数",
        download: "财务报表明细",
        options_company: "全部景区",

    },
    ticketlog: {
        options_company: "记录日期",
        ticketID: "票号",
        cz: "操作类型",
        company: "所属景区",
        zone: "所属景点",
        dev: "设备列表",
        zx: "执行结果",
        query: "查询",
        id: "序号",
        deviceName: "设备名称",
        scenicareaName: "所属景区",
        zoneName: "所属景点",
        operate: "操作类型",
        operateType: "操作",
        exec_result: "执行结果",
        param1: "参数1",
        param2: "参数2",
        recordTime: "记录时间",
        text1: "最近一周",
        text2: "最近一个月",
        text3: "最近三个月",
        label1: "门信息",
        label2: "人员信息",
        label3: "票类型",
        label4: "票信息",
        label5: "通行组",
        label6: "日程表",
        label7: "门组信息",
        label8: "计费规则",
        label9: "远程开闸",
        label10: "远程升级",
        label11: "区域管控",
        label12: "清理数据库",

        label13: "执行成功",
        label14: "未执行",
        label15: "执行失败",
        error: "票长度不能大于18个字符",
    },

    center: {
        accountNumber: "账号",
        userId: "用户ID",
        userName: "用户名称",
        companyCode: "编码",

        updataForm: "修改密码",
        oldPassword: "旧密码",
        newPassword: "新密码",
        newPassword1: "确认密码",
        newPassword1: "确认密码",

        Error1: "旧密码不能为空",
        Error2: "旧密码长度必须在1-12位",
        Error3: "新密码不能为空",
        Error4: "新密码长度必须在1-12位",
        Error5: "确认密码不能为空",
        Error6: "确认密码长度必须在1-12位",
        Error7: "次输入的确认密码不一致",
        Error8: "修改密码成功",
        Error9: "修改密码失败,请认真核对旧密码跟新密码",
        Error10: "修改密码失败",

    },
    ticketsell: {
        name: "票名称",
        ticketDisplayPrice: "显示价格",
        price: "票出售价",
        num: "购票数量",
        price: "票出售价",
        numlist: "票总价",
        countList: "订单总金额",
        countnum: "订单总数量",
        countList_: "应收金额",
        fs: "优惠方式",
        zf: "支付",
        zf1: "现金",
        zf2: "收付款码",
        zf3: "微信",
        zf4: "支付宝",
        zf5: "银联",
        zf10: "挂账",
        ss: "实收",
        zl: "找零",
        ys: "应收",
        yh: "优惠",
        cardMethod1: "单卡",
        cardMethod2: "多卡",
        touristName: "姓名",
        touristMobile: "手机号码",
        touristIDCardNum: "身份证",
        touristCompany: "单位信息",
        card_id: "读取身份证",
        radio_1: "一人一票",
        radio_2: "一票多人",
        add: "点击出票",
        updataForm: "扫码方式",
        updata: "确 定",

        Error: "不能为空或者0",
        Error1: "游客",
        Error2: "未找到身份证",
        Error3: "未找到身份证驱动,或服务错误,请联系管理员",
        Error4: "请扫付款码",
        Error5: "支付成功，购票成功",
        Error6: "支付失败，出票未成功",
        Error7: "出票失败",
        Error8: "不优惠",
        Error9: "请选择要出售的票种",
        Error10: "一票多人只能选一种票类型销售",
        Error11: "出票中请等待打印",
        Error12: "购票成功",
        Errorx: "支付中请等待",

        card: "会员卡类型",
        cardCategory: "卡类别",
        ticketFeeMethod: "卡介质",
        ticket_card: "会员卡号",
        IDcardticketMedium: "身份证号",
        ICcard_T: "会员天数",
        ICcard_Y: "会员月数",
        ICcard_N: "会员年数",
        name_: "姓名",
        mobile: "手机号",
        countList_d: "卡单价",
        type: "会员介质",

        upload: "人脸照片",
        upload_: "上传图片",
        elupload: "只能上传jpg/png文件,且不超过1MB",

        Errorc1: "请选择会员卡类型",
        Errorc2: "卡号不能为空",
        Errorc3: "姓名不能为空",
        Errorc4: "手机号不能为空",
        Errorc5: "请输入正确的手机号",
        Errorc6: "购票成功,打印失败！打印模板没有建立,请核对后台打印模板",
        Errorc7: "票已存在,是否重新销售！",
        Errorc8: "提示",
        Errorc9: "请选择票类型",

        Errorc10: "请输入有效的天数,不得超过6000",
        Errorc11: "请输入有效的天数",
        Errorc12: "请输入会员天数",
        Errorc13: "请输入有效的月数",
        Errorc14: "请输入有效的月数,不得超过100",
        Errorc15: "请输入会员月数",
        Errorc16: "请输入有效的年数",
        Errorc17: "请输入有效的年数,不得超过30年",
        Errorc18: "请输入会员年数",
        Errorc19: "卡号不能为空",
        Errorc20: "卡号不能为空",
        Errorc21: "姓名不能为空",
        Errorc22: "卡长度不能大于24个字符",
        Errorc23: "身份证长度不能大于18个字符",
        Errorc24: "电话长度不能大于11个字符",
        Errorc25: "姓名长度不能大于10个字符",
        Errorc26: "卡号不能带中文字符,请确认您的输入法,或者重新输入",

        cz: "充值金额",
        zs: "充值赠送",
        cr: "卡实际充入金额",
        czje1: "请输入充值金额",
        czje2: "充值金额不能为0",

        primary: "确 定",
        close: "取 消",

        time: '时间',


        query: '查询卡号',
        ticketID: '卡号',
        ticketID_: '处理卡号',
        id: "序号",
        ticketPrice: "单价",
        ticketTypeName: "票类名称",
        ticketCate: "票类别",
        ticket_Cate: "票类别ID",
        ticketFeeMethod: "票介质",
        ticketBalance: "票余额",
        ticketStatus: "票状态",
        ticketStart: "游玩日期",
        ticketEnd: "结束时间",
        subTicketID: "票参数",
        xf: "续费",
        gs: "挂失",
        jg: "解挂",
        bk: "补卡",
        y1: "1月",
        y3: "3月",
        y6: "6月",
        j1: "1季",
        j3: "3季",
        j6: "6季",
        n1: "1年",
        n2: "2年",
        n3: "3年",
        n6: "6年",
        b1: "半年",

        time1: "续费时间(月)",
        time2: "续费时间(季)",
        time3: "续费时间(年)",
        time4: "续费时间(天)",
        price1: "续费金额",
        price2: "充值金额",
        price2: "充值金额",
        zh: "总额",
        list_cz: "卡续费额",
        card_xu: "确认续费",
        newcard_ID: "补卡卡号",
        card_bu: "确认补卡",
        qt: "其他",

        makForm: "门票景点参数详情",
        scope: "景点",
        remainTimesByDay: "总次数",
        remainTimes: "剩余次数",
        remainValidTime: "剩余时间",
        message1: "续费成功",
        message2: "续费失败",
        message3: "请先选择续费时间",
        message4: "此操作将禁用该卡, 是否继续",
        message5: "挂失成功",
        message6: "挂失失败",
        message7: "此操作将解挂该卡, 是否继续",
        message8: "解挂成功",
        message9: "解挂失败",
        message10: "请输入查询的某一个内容",
        message11: "续费金额不能为空，请输入金额",
        message12: "续费金额不对，请输入正确金额",
        message13: "请选择续费时间",

        message14: "续费的天数不能大于5000天",
        message15: "续费的月数不能大于100月",
        message16: "续费的年数不能大于20年",
        message17: "卡号不能为空，请核对选择的卡号",
        message18: "此操作将完成补卡操作,新卡将完全继承旧卡的信息数据, 是否继续",
        message19: "补卡卡号不能相同",
        message20: "补卡卡号不能为空",
        message21: "补卡成功",
        message22: "补卡失败",
        message23: "该卡的状态无法补卡",
        message24: "普通卡无法补卡",
        message25: "团体卡无法补卡",
        message26: "获取卡信息成功，请在下方操作",
        message27: "该卡的状态无法续费",
        message28: "普通卡无法续费",
        message29: "团体卡无法续费",
        ticketMedium: "票介质",
        ticketBalance: "剩余金额",
        return_card: "输入卡号/票号/订单号",
        ticketID_return: "票号",
        isRefund: "是否可退",
        refundAmount: "剩余金额",
        orderPayment: "付款方式",
        ticketFeeMethod_: "计费方式",
        list_yt: "应退",
        list_sx: "手续费",
        list_st: "实退",
        orderPaymentID: "退款ID",
        zfisRefund: "退款支付",
        zf6: "微信付款码",
        zf7: "支付宝付款码",
        zf8: "公众号付款",
        zf9: "小程序付款",
        refund: "确认退票",
        refund_1: "不可退",
        refund_2: "可退",

        message30: "请输入票号，或者订单号",
        message31: "该票号或订单里面没有可退的票，可前往门票查询出具体状态信息",
        message34: "请选择需要退的票",
        message32: "退票成功",
        message33: "退票失败",

        qp: "门票取票",

        hx_: "门票核销",
        change: "门票信息修改",
        qplist: "门票处理/门票取票",
        text: "通过查询游客信息，可将游客手中的电子二维码打印成纸质二维码。与门票状态无关。选择你需要打印的门票，也可全选打印。",
        cardlist: "订单/票号",
        print: "打印门票",
        orderID: "订单",
        account: "售票员",
        ticketUserCompany: "单位",
        qplist_: "门票处理/门票核销",
        text_: "通过查询游客信息，订单为DD开头的18位号码，票号为单字母开头的18位号码，如果票状态为未验票，点击核销后，门票相对于验票，无法通过闸机等设备。",
        cardlist_: "输入票号/或者订单号",
        cardlist_list: "票号/订单号",
        query_list: "查询信息",
        query_: "查询需要核销的票信息",
        orderIDhx: "全部核销",
        hx: "核销",
        warning1: "请输入需要查询的数据",
        warning2: "卡长度不能大于24个字符",
        warning3: "姓名长度不能大于10个字符",
        warning4: "身份证长度不能大于18个字符",
        warning5: "此操作将票核销, 是否继续",
        warning6: "核销成功",
        warning7: "核销失败",
        warning8: "核销失败，请联系管理员",
        warning9: "此操作将订单内的门票全部核销掉, 是否继续",
        warning10: "请选择你需要打印的门票",
        warning11: "此操作将票打印, 是否继续",
        warning12: "打印成功",
        warning13: "打印失败",
        warning14: "打印失败，请联系管理员",
        warning15: "取消打印",


        ticketCount: "购票总数",
        OrdinaryCard: "普通卡",
        StoreCard: "储值卡",
        MembershipCard: "会员卡",
        GroupCard: "团体卡",
        RticketCount: "退票总数",
        amount: "收银总额",
        Cash: "现金",
        Alipay: "支付宝",
        WeChat: "微信",
        UnionPay: "银联",
        Bought: "挂账",
        Ramount: "退款总额",
        RCash: "退现金",
        RAlipay: "退支付宝",
        RWeChat: "退微信",
        RUnionPay: "退银联",
        RBought: "退挂账",
        Samount: "实收总额",
        xd: "下单记录",
        xq: "门票详情记录",
        ticketNum: "张数",
        orderAmount: "订单金额",
        preferentialAmount: "优惠金额",
        orderTime: "下单时间",
        orderPayment: "支付方式",
        orderStatus: "状态",
        id_query: "修改支付",
        orderData: "查看订单详情",
        hidelist: "门票详情记录",
        ticketSum: "购票张数",
        refundTicketSum: "退票张数",
        actualAmount: "实际销售金额",
        ticketRechargeAmount: "余额",
        printticket: "打印",
        updataForm_: "编辑支付方式",

        zoneData: "对应景点参数",

    },
    ticketCollection: {
        ticketLibraryList: "票库列表",
        ticketCollection: "领票管理",
        warehousingOperation: "入库操作",
        operationRecords: "操作记录",
        ticketLibraryName: "票库名称",
        residueNum: "剩余数量",
        operator: "操作员",
        startNum: "起始编号",
        endNum: "结束编号",
        num: "数量",
        year: "所属年份",
        add: "添加",
        addTitle: "添加记录",
        addTicket: "添加记录",
        editTitle: "编辑票库",
        editTicket: "编辑入库",
        editCollection: "编辑领票",
        receiptQuantity: "入库数量",
        warehousingTime: "入库时间",
        operatingTime: "操作时间",
        isNum: "编号不能为空",
        numLength: "编号长度不得超过十位",
        numType: "编号只能为纯数字",
        addCollection: "添加领票",
        ticketsReceivedNum: "领票数量",
        ticketsReceivedTime: "领票时间",
        ticketsReceivedCollector: "领票人员",
        returnedNum: "退库数量",
        returnedstartNum: "退库起始编号",
        returnedendNum: "退库结束编号",
        returnedCollector: "退库人员",
        returnedTime: "退库时间",
        totalInboundQuantity: "入库总数量",
        totalTicketsReceivedNum: "领票总数量",
        totalReturnedNum: "退库总数量",
        totalRemainingQuantity: "剩余总数量",
        remark: "备注"
    },



    ticket: {

        yes: "是",
        no: "否",
        reset: "重 置",
        primary: "确 定",
        remark: "备注",
        scope: "操作",
        close: "取 消",
        successadd: "添加信息成功",
        erroradd: "添加信息失败",
        successedit: "编辑信息成功",
        erroredit: "编辑信息失败",
        delete: "此操作将永久删除该数据, 是否继续?",
        warning: "提示",
        deletesuccess: "删除信息成功",
        deleteerror: "删除信息失败",
        headPhoto: "上传头像图片只能是 JPG 或者PNG 格式",
        headPhoto1: "上传头像图片大小不能超过 1MB",
        //补译
        setqx: "自定义下发权限",
        deviceParam: "设备基础参数",
        ticketTypeParam: "票权限参数",
        ordinaryTicketParam: "普通票信息",
        membershipTicketParam: " 会员卡信息",
        Errorx13: "处理中...",
        company: "请选择景区",
        addForm_: "设备同步设置",
        deviceSoftVersion: "控制器版本",
        zdyqx_query: "自定义权限下发",
        tt: "同步说明：后台默认会跟设备实时同步数据,若后台交互频繁(园区旺季时),可以将同步关闭，系统切换为设备主动请求软件后台,大大减少后台服务器压力",
        company_: "所属景区",
        tt_: "是否同步",
        tt_title: "同步设置",
        addFormdata_: "更多票类设置",
        isIncomeDistribution: "是否分配收益",
        touristType: "游客类型",
        enterMethod: "过闸方式",
        isAppointmentEnable: "是否开启微信预约",
        saleEndTime: "微信下单限制时间",
        isGetTicketPass: "是否取票通行",
        isRefundCheck: "是否退票审核",
        wx: "微信预订说明",
        isRealName: "是否要身份证",
        enterMode: "入园时间",
        reservationInstructions: "使用方法",
        detailsExplain: "游玩项目说明",
        makForm_gj: "票类高级参数列表",
        add_gj: "添加票类高级参数",
        id: "序号",
        personTicketBindingMode: "身份证模式",
        enablePasswordMode: "读取密码审核",
        checkRefundMode: "是否强制退票",
        addForm_gjlist: "票类高级参数添加",
        checkPassword: "审核密码",
        updataForm_gjlist: "编辑票类高级参数",
        enterMethod1: "一人一票",
        enterMethod2: "一票多人",
        touristType1: "普通",
        touristType2: "1.3米、6周岁（含）以下儿童",
        touristType3: "未成年人",
        touristType4: "学生",
        touristType5: "老年人",
        touristType6: "残疾人",
        touristType7: "现役军人",
        touristType8: "现役军人家属",
        touristType9: "军队离退休人员",
        touristType10: "残疾军人",
        touristType11: "烈士遗属",
        touristType12: "公安民警",
        touristType13: "消防救援人员",
        touristType14: "医护人员",
        touristType15: "教师",
        touristType16: "本地户籍人员",
        touristType17: "导游",
        touristType18: "司陪人员",
        touristType19: "媒体记者",
        touristType20: "政策规定优惠人员",
        touristType21: "大学生",
        touristType22: "中学生",
        touristType23: "小学生",
        touristType24: "一票多人",
        personTicketBindingMode1: "一证一人",
        personTicketBindingMode2: "一证多人",
        enablePasswordMode1: "不开启",
        enablePasswordMode2: "开启",
        /* 补译*/
        areaName: "类型为身份证免费卡时，区域关键字不能为空",
        minAge: "类型为身份证免费卡时，年龄不能为空",
        minAge1: "类型为身份证免费卡时，区域关键字不能大于180个字符",
        minAge2: "类型为身份证免费卡时，年龄不能大于3个字符",
        minAge3: "类型为身份证免费卡时，必须选择类型",
        minAge4: " 限制时间跨度不能大于1年",

        card: "按模板编辑好会员信息，在选择好对应的票类型，状态只能选择未验票还是未激活，选择未验票，卡类将直接销售出去，卡直接开始使用，未激活会将卡销售出去，但必须到窗口二次激活，卡有效开始时间为激活时间",
        upload: "选择文件",
        upload1: "上传会员信息",
        excel: "导出会员信息",
        jihuo: "激活",

        upload2: "上传失败,请认真核对人员信息",
        jihuo1: "此操作将卡激活,是否继续操作 ",
        jihuo2: "此操作将卡激活，激活后卡将可以使用",
        jihuo3: "激活成功",
        jihuo4: "激活失败",
        cardtext: "会员卡信息",
        ticketRefund: "退票明细",
        Supplementary: "补取明细",
        goods: " 商品设置",
        shops: "商铺管理",
        gatalogue: "商品目录",
        commodity: "商品明细",
        goodsloading: "商品录入",
        Inventory: "商品库存明细",
        Commoditysales: "商品订单明细",
        Salesdetails: "商品销售明细",
        Entry: "门票录入",
        Ticket_Inventory: "门票库存",
        Warehouse: "库存管理",
        Shareholder: "股东管理",
        Share: "股东权益",
        Statement: "收益明细",
        mobileTerminal: "移动端",
        ticketVerification: "票类核验",
        membershipCardSelect: "会员卡查询",
        dataStatistics: '数据统计',
        dataReporting: '文旅平台数据上报',
        freeTicketChannel: '体验通道',
        deletion: '一键删除',
        scan: "扫描售票",
        sellgoods: "销售商品",
        annualCardActivation: '年卡激活',
        useType: "使用类型",
        Mobile: "电话",
        Mobile1: "输入电话",
        actualOrderAmount: "实际订单金额",
        inValidOrderCount: "无效订单数",
        refundOrderAmount: "退票订单金额",
        refundOrderCount: "退票订单数",
        totalOrderCount: " 总订单数",
        totalValidOrderAmount: "有效订单金额",
        totalValidOrderCount: "有效订单数",
        touristIDCardNum: "身份证",
        ota: "OTA来源",
        lyd: "来源地",
        unUsedTicketAmount: "未核销票金额",
        unUsedTicketCount: "未核销票张数",
        usedTicketAmount: "核销票金额",
        usedTicketCount: "核销票张数",
        refundTicketAmount: "退票金额",
        refundTicketCount: "退票张数",
        tickettime: "购票时间",
        headPhoto: "照片",
        wu: "无",
        ticketChannel: "分销来源",
        totalCount: " 总次数",
        enterCount: " 进次数",
        outCount: "出次数",
        realTimeCount: " 在场次数",
        zoneName: "景点",
        deviceName: "设备",
        enterCount1: "进出明细",
        query1: "进出明细统计",
        query2: "设备进出明细",
        headPhoto: "照片",
        ticket_card: "输入会员卡号",
        IDcardticketMedium: "输入身份证号",
        transPrice: "交易单价",
        ticketStatus: "下单时间",
        rticket: "退门票",
        rgoods: "退商品",
        ticket_qz: "强制退票",
        return_text: " 强制退票(已核销或已用的门票在这里强制退票)",
        isRefundCheck: "是否审核",
        refundCheckStatus: "审核状态",
        usedTime: "使用时间",
        cz: "操作",
        RefundCheck: "提交审核",
        printtext1: "【门票打印】",
        printtext2: "【订单打印】输入的查询的号码为DD开头的订单号,并且该订单下的门票只有一种,那么订单打印时可将订单下的门票,只会打印成一个二维码,二维码里面的权限可以过对应门票的权限次数",
        printtext3: "订单打印",
        hx1: "景点核销",
        hx2: "批量核销",
        hx3: "全域核销",
        hx4: "【景点核销】通过查询游客信息，订单为DD开头的18位号码，票号为单字母开头的18位号码，如果票状态为未验票，查看可核销信息,点击核销可核减1次对应景点下的通行次数",
        hx5: "【全域核销】通过查询游客信息，订单为DD开头的18位号码，票号为单字母开头的18位号码，如果票状态为未验票，点击核销后,票状态直接更改为已验票(慎用)",
        hx6: "【批量核销】通过查询游客订单为DD开头的18位号码，可根据查询到的可通行门票数量,批量的核减一次对应景点下的门票通行次数",
        totalTicketCount: "门票数量",
        validTicketCount: "可通行票数",
        totalValidTimes: "可通行次数",
        hx7: "最高可核销数",
        hx8: "核销数量",
        hx9: "核销门票",
        checkPeopleCount: "输入需要核销的数量",
        hxnum: "核销的数量不能大于最大的可核销数",
        msgCode: "核销成功",
        ticketID: "输入需要查询的订单号",
        ticketIDlength: "输入长度不能大于24个字符",
        Error: "此操作将只会出票一张, 票会记录在补取明细中, 是否继续?",
        printwarning: "订单打印失败,订单中只能含有一个票种",
        printwarning1: "数据错误,打印订单失败",

        printwarning2: "此操作将票打印, 票会记录在补取明细中, 是否继续?",
        settledAmount: " 结算金额",
        unSettledAmount: "未结算",
        Samount_dq: "当前总额",
        Samount_dq_: "当前总退款",
        Samount_last: "当前实收",
        settledAmount_last: "当前结算",
        unSettledAmount_last: "未结算",
        addjjb: "交接班操作",
        addgoods: "商品明细",
        goodslist: "商品销售明细",
        changeShiftsName: "交班",
        amount: "实收总额",
        settledAmount: "结算金额",
        startTime: "交接班开始时间",
        endTime: "交接班结束时间",
        operator: " 提交人",
        operator1: " 此操作将当前的实收金额提交结算并且生成交班记录,是否继续操作",
        operator2: " 提示",
        operator3: " 提交成功",
        operator4: " 提交失败",
        query_pl: " 查询订单",
        rquery1: " 退票审核明细",
        rquery2: " 退票明细",
        orderPayment: "支付方式",
        createTime: " 提交时间",
        orderAmount: " 下单金额",
        account: " 提交审核人员",
        refundCheckStatus: " 审核状态",
        orderTime: "退票时间",
        SRoot1: "审核中",
        SRoot2: "已审核",
        SRoot3: "已驳回",
        SRoot4: "审核失败",
        textx1: " 此操作将审核成功金额将会退回并生成一个退款订单, 是否继续",
        textx2: "审核成功",
        textx3: " 此操作将该票驳回退票请求, 是否继续",
        text4: "驳回成功",
        text5: "驳回失败",
        ticket1: "门票报表",
        ticketjjb: "交接班",
        ticket_zh: "综合查询",
        tj: "条件",
        queryly: "导出来源报表",
        ticketTypeName: "票类型",
        ticketPrice: "票单价",
        ticketPrice: "票单价",
        ticketCount: " 销售数量",
        amount1: " 总额",
        offline_ticketCount: " 线下销售数",
        offline_amount: " 线下销售金额",
        OTA_ticketCount: " 线上销售数量",
        OTA_amount: " 线上销售金额",
        OTA_amount: " 线上销售金额",
        amount2: "总金额",
        totalTicketCount: "售票总数",
        window_cashTicketCount: " 窗口现金票数",
        window_cash: "  窗口现金收银",
        window_wxTicketCount: "窗口微信票数",
        window_wxAmount: "窗口微信收银",
        window_zfbTicketCount: "窗口支付宝票数",
        window_zfbAmount: "窗口支付宝收银",
        terminal_wxTicketCount: "终端机微信票数",
        terminal_wxAmount: "终端机微信收银",
        terminal_zfbTicketCount: "终端机支付宝票数",
        terminal_zfbAmount: "终端机支付宝收银",
        OTA_ticketCount: "OTA分销票数",
        OTA_amount: "OTA分销金额",
        shareHolderName: "收益公司",
        shareHolder: "收益",
        refundCount: "退票张数",
        refundTodayTicketCount: "退当日下单票数",
        refundPreviousTicketCount: "退往日下单票数",
        businessTicketCount: "统计交易票数",
        textly1: "线上分销渠道明细",
        textly2: "票类型统计",
        textly3: "票来源统计",
        ptkly: "来源明细",
        textentry: "按模板编辑好票信息，在选择好对应的票类型，状态只能选择未验票还是已入库，选择未验票，票类将直接销售出去，票直接开始使用！已入库的票将放入票仓，前端销售使用",
        textexcel: "上传文件",
        uptabledata: "上传票信息",
        textentry1: "入库操作成功后,票信息在门票库存中可查看。当以未验票状态导入操作成功后。票直接绑定到售票员账号销售出去。并且会生成一笔订单。在订单明细中查看，票信息也会存在门票库存报表中",
        textentry2: "导入时间",
        textentry3: "入库票号",
        textentry4: "删除票信息",
        ticketzt: "导入状态",
        ticketzt1: "已入库",
        ticketzt2: "上传失败,请认真核对票信息",
        qx: "取 消",
        ticketzt3: "票长度不能大于18位！上传效验失败",
        ticketzt4: "票长度不能有空！上传效验失败",
        ticketzt5: "票号含有中文或特殊字符，上传效验失败",
        ticketzt6: "有重复票号",
        ticketzt7: "请上传文件",
        ticketzt8: "请选择景区",
        ticketzt9: "请选择状态",
        ticketzt10: "请选择绑定的售票员",
        ticketzt11: "请选择绑定的票类型",
        ticketzt12: "上传信息成功",
        ticketzt13: "上传信息失败",
        ticketzt14: " 附件格式错误，请删除后重新上传",
        ticketzt15: " 请上传附件",
        ticketzt16: " 请选中需要删除的票",
        ticketzt17: "该操作将删掉选中的票据",
        ticketztx: "未验票",

    },
    btn: {
        add: "新增",
        edit: "编辑",
        delete: "删除",
        query: "查询",
        download: "下载",
        submit: "提 交",
        cancel: "取 消",
        reset: "重 置",
        personnelAuthorization: "人员授权",
        text2: "技术支持",
        text3: "请使用IE9及以上版本、EDGE、谷歌、Opera浏览器登录",
        text4: " 账户不能为空",
        text5: " 密码不能为空",
        text6: "登录成功，正在加载.....",
        text7: "登录失败，服务未连接",
        touristMobile: "手机长度不能大于11位",
        touristIDCardNum: "身份证长度不能大于18位",
        touristPhoto: " 您选择的类型需要拍照,请拍照后再提交订单",
        arr: "  您选择的特殊游客类型一个订单只能有一种",
        print: "打印控件服务未启动,将启动服务,请在弹出的窗口点击打开",

        countnum: "录入的数量有误，不能为空",
        countnum1: "一次下单不能大于100张",
        xlabel1: "无",
        xlabel2: "微信公众号",
        xlabel3: "自助终端机",
        xlabel4: "OTA",
        xlabel5: "微信小程序",


    },
    egsRouteName: {
        home: '主页',
        personnelList: '人员名单'
    },
    rightMenu: {
        close: '关闭',
        closeOther: '关闭其他',
        closeAll: '全部关闭'
    },
    role: {
        superAdmin: '超级管理员',
        admin: '管理员',
        ordinary: '普通用户'
    },
    userDropdownMenu: {
        basicInfor: '基本资料',
        changePassword: '修改密码',
        logout: '退出'
    },
    message: {
        selectNoData: '未查询到数据',
    },

    ...zhLocale //  合并element-ui内置翻译
}

export default cn


// WEBPACK FOOTER //
// ./src/i18n/lang/zh-CN.js